import { trimFormatter } from './trim';

export const phoneNumberFormatter = (phoneNumber = ''): string => trimFormatter(phoneNumber).replace(/[() -]/g, '');
